import { useRegion } from 'common/hooks/region';
import * as React from 'react';
import { Terminal } from 'services/clients/terminal';
import { AgnosticTerminalSelector } from './AgnosticTerminalSelector';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onInitialLoad?: (terminals: Terminal[]) => void;
}

export const TerminalSelector: React.FC<Props> = (props) => {
  const region = useRegion();
  return <AgnosticTerminalSelector {...props} region={region} />;
};
TerminalSelector.displayName = 'Selector.Terminal';
